var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_108274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 19,
    stroke: "#1192E8",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(14 10)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 25C18.7202 25 19 24.7202 19 24.375C19 24.0298 18.7202 23.75 18.375 23.75C18.0298 23.75 17.75 24.0298 17.75 24.375C17.75 24.7202 18.0298 25 18.375 25Z",
    fill: "#1192E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 13.75H15.25V15H17.75V13.75Z",
    fill: "#1192E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13.75H19V15H21.5V13.75Z",
    fill: "#1192E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 13.75H22.75V15H25.25V13.75Z",
    fill: "#1192E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.75H26.5V15H29V13.75Z",
    fill: "#1192E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 13.75H30.25V15H32.75V13.75Z",
    fill: "#1192E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27.5H16.5C16.1686 27.4997 15.8508 27.3678 15.6165 27.1335C15.3822 26.8992 15.2503 26.5814 15.25 26.25V22.5C15.2503 22.1686 15.3822 21.8508 15.6165 21.6165C15.8508 21.3822 16.1686 21.2503 16.5 21.25H31.5C31.8314 21.2503 32.1492 21.3822 32.3835 21.6165C32.6178 21.8508 32.7497 22.1686 32.75 22.5V26.25C32.7497 26.5814 32.6178 26.8992 32.3835 27.1335C32.1492 27.3678 31.8314 27.4997 31.5 27.5ZM16.5 22.5V26.25H31.5V22.5H16.5Z",
    fill: "#1192E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 17.5H15.25V18.75H32.75V17.5Z",
    fill: "#1192E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_108274",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_108274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_108274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeLegend);
export default __webpack_public_path__ + "static/media/nodeLegend.f0ba0396547e93015514b2369b6c1d1a.svg";
export { ForwardRef as ReactComponent };